import { Address } from "../Address";

export class Person {
  email: string;
  id: string;
  language: string;
  name: string;
  personType: string;
  phone: string;
  address: Address;
  buildingId: string;

  constructor(
    email?: string,
    id?: string,
    language?: string,
    name?: string,
    personType?: string,
    phone?: string,
    address?: Address,
    buildingId?: string
  ) {
    this.email = email;
    this.id = id;
    this.language = language;
    this.name = name;
    this.personType = personType;
    this.phone = phone;
    this.address = this.address ? address : new Address();
    this.buildingId = buildingId;
  }
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
